import { setLocale } from 'yup'

setLocale({
  date: {
    max: '${max} é um data inválida',
  },
  mixed: {
    required: 'Este campo é obrigatório',
    default: 'Não é válido',
  },
  string: {
    email: 'Email inválido',
    max: 'Deve ser menor que ${max}',
    min: 'Deve ser maior que ${min}',
  },
  number: {
    positive: '${integer} deve ser um número positivo',
    integer: '${integer} deve ser um número inteiro',
    max: 'Deve ser menor que ${max}',
    min: 'Deve ser maior que ${min}',
  },
})
